import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import meReducer from '../features/me/me';
import plansReducer from '../features/plans/plans';
import addonsReducer from '../features/addons/addons';
import routersReducer from '../features/routers/routers';
import termsReducer from '../features/terms/terms';
import campaignsReducer from '../features/campaigns/campaigns';
import referralsReducer from '../features/referrals/refarrals';
import searchReducer from '../features/search/search';
import activeReservationsReducer from '../features/active_reservations/active_reservations';
import accountsReducer from '../features/accounts/accounts';
import signupStatsReducer from '../features/signupStats/signupStatsSlice';
import reconciliationReducer from '../features/reconciliation/reconciliation';
import buildingEditorReducer from '../features/buildingEditor/buildingEditor';
import cfOrdersReducer from '../features/cfOrders/cfOrders';
import disclaimersReducer from '../features/disclaimers/disclaimers';

export const store = configureStore({
  reducer: {
    me: meReducer,
    plans: plansReducer,
    addons: addonsReducer,
    routers: routersReducer,
    terms: termsReducer,
    campaigns: campaignsReducer,
    referrals: referralsReducer,
    active_reservations: activeReservationsReducer,
    search: searchReducer,
    accounts: accountsReducer,
    signupStats: signupStatsReducer,
    reconciliation: reconciliationReducer,
    buildingEditor: buildingEditorReducer,
    cfOrders: cfOrdersReducer,
    disclaimers: disclaimersReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
